
export const reductionRouting = [
	{
    path: "/assetManage/reduction/list",
    name: "reduction-list",
    meta: { title: "报废信息登记" },
    component: () =>
      import(/* webpackChunkName: "reduction-list" */ "@/views/asset-management/reduction/list/index.vue"),
  },
	{
    path: "/assetManage/reduction/create",
    name: "reduction-create",
    meta: { title: "新建报废登记" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "reduction-create" */ "@/views/asset-management/reduction/form-create/index.vue"),
  },
	{
    path: "/assetManage/reduction/edit/:id",
    name: "reduction-edit",
    meta: { title: "编辑报废登记" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "reduction-edit" */ "@/views/asset-management/reduction/form-create/index.vue"),
  },
	{
    path: "/assetManage/reduction/detail/:id",
    name: "reduction-detail",
    meta: { title: "报废登记详情" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "reduction-detail" */ "@/views/asset-management/reduction/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/assetManage/reduction/flowPrint/:id",
    name: "reduction-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "reduction-flow-print" */ "@/views/asset-management/reduction/flow-print/index.vue"
      ),
  },
]